function App() {
  return (
    <div style={{ padding: "32px", fontFamily: "Arial, sans-serif" }}>
      <h1>Personal AI Wealth Manager</h1>
      <p>
        Upload financial statements, view forecasts, and detect anomalies.
      </p>

      <h2>Sprint 0 Placeholder</h2>
      <ul>
        <li>Upload Statements</li>
        <li>Forecast Dashboard</li>
        <li>Anomaly Alerts</li>
      </ul>
    </div>
  );
}

export default App;
